class CategoryIconsSlider {
  constructor() {
    this.slider = document.querySelector('.category-icons__list');
    if (!this.slider) return;

    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.isDragging = false;

    this.init();
  }

  init() {
    // Only enable mouse drag on screens 750px and larger
    if (window.matchMedia('(min-width: 750px)').matches) {
      this.slider.addEventListener('mousedown', this.handleMouseDown.bind(this));
      this.slider.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.slider.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.slider.addEventListener('mousemove', this.handleMouseMove.bind(this));
      
      // Prevent text selection while dragging
      this.slider.addEventListener('selectstart', (e) => {
        if (this.isDown) {
          e.preventDefault();
        }
      });
    }
  }

  handleMouseDown(e) {
    // Don't start drag if clicking on a link
    if (e.target.closest('a')) {
      return;
    }

    this.isDown = true;
    this.slider.style.cursor = 'grabbing';
    this.slider.style.userSelect = 'none';
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
    this.isDragging = false;
  }

  handleMouseLeave() {
    if (this.isDown) {
      this.isDown = false;
      this.slider.style.cursor = 'grab';
      this.slider.style.userSelect = '';
    }
  }

  handleMouseUp(e) {
    if (!this.isDown) return;

    this.isDown = false;
    this.slider.style.cursor = 'grab';
    this.slider.style.userSelect = '';

    // If we were dragging, prevent click events on links
    if (this.isDragging) {
      e.preventDefault();
      const link = e.target.closest('a');
      if (link) {
        link.style.pointerEvents = 'none';
        setTimeout(() => {
          link.style.pointerEvents = '';
        }, 0);
      }
    }
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();

    this.isDragging = true;
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 2; // Scroll speed multiplier
    this.slider.scrollLeft = this.scrollLeft - walk;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CategoryIconsSlider();
  });
} else {
  new CategoryIconsSlider();
}

